module.exports = __webpack_public_path__ + "static/media/5.5f8bd0d5.jpg";